module.exports = __webpack_public_path__ + "img/diet-4.1b656d6c.jpg";